import config from "../../config"
import RequestService from "../RequestService"

const fetchMaterials = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/materials`, successCallback, failureCallback)
}

export default fetchMaterials;